import { computed, signal } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { LoginResponse, LogoutAuthOptions } from 'angular-auth-oidc-client';
import { EMPTY, Observable } from 'rxjs';
import { USER_PROFILE_MOCK } from '../../models/oauth-profile.response.mock';

export class OAuthServiceMock {
  public authorize: () => void = jest.fn();

  public authorizeWithPopUp: () => Promise<LoginResponse | undefined> = jest.fn(() =>
    Promise.resolve({
      isAuthenticated: true,
      accessToken: 'accessToken',
      configId: 'token',
      idToken: 'idToken',
      refreshToken: 'refreshToken',
      expiresAt: 1000000000000,
      userData: USER_PROFILE_MOCK,
    } as LoginResponse),
  );

  public readonly setAuthenticated = signal(true);

  public readonly authenticated = computed(() => this.setAuthenticated());

  public isAuthenticated: (configId?: string) => Promise<boolean> = jest.fn(
    (_configId?: string) => {
      const authenticated = this.setAuthenticated();
      return Promise.resolve(authenticated);
    },
  );

  public refreshAccessToken: () => Promise<boolean> = jest.fn(() => Promise.resolve(true));

  public requestIfTheUserWantsToLogOut: () => Promise<void> = jest.fn(() => Promise.resolve());

  public logout: (configId?: string, logoutAuthOptions?: LogoutAuthOptions) => Promise<boolean> =
    jest.fn((_configId?: string, _logoutAuthOptions?: LogoutAuthOptions) => Promise.resolve(true));

  public logoff: (configId?: string, logoutAuthOptions?: LogoutAuthOptions) => Observable<unknown> =
    jest.fn((configId?: string, logoutAuthOptions?: LogoutAuthOptions) => {
      return EMPTY;
    });

  public logoffAndRevokeTokens: (
    configId?: string,
    logoutAuthOptions?: LogoutAuthOptions,
  ) => Observable<unknown> = jest.fn((configId?: string, logoutAuthOptions?: LogoutAuthOptions) => {
    return EMPTY;
  });

  public getForbiddenUrlTree: () => UrlTree = jest.fn(() =>
    new DefaultUrlSerializer().parse('/forbidden'),
  );

  public getUnauthorizedUrlTree: () => UrlTree = jest.fn(() =>
    new DefaultUrlSerializer().parse('/unauthorized'),
  );
}
